
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import {
    HTTP_INTERCEPTORS,
    withInterceptorsFromDi,
    provideHttpClient,
} from '@angular/common/http';
import { TokenInterceptor } from './app/service/core/interceptor.service';
import { LOCALE_ID, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { provideRouter } from '@angular/router';
import { AppRoutes } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app/app.component';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { AlterarSenhaGuard } from './app/auth/alterar-senha/alterar-senha-guard';


// Dados de localidade do Angular para o LOCALE_ID pt-BR (DatePipe, números etc.).
registerLocaleData(localePt);

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(
            BrowserModule,
            ConfirmDialogModule,
            ButtonModule,
            FontAwesomeModule
        ),
        // { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: APP_BASE_HREF, useValue: '/' },
        provideRouter(AppRoutes),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        MessageService,
        AlterarSenhaGuard,
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    cssVars: true,
                    darkModeSelector: false || 'none',
                    cssLayer: {
                        name: 'primeng',
                        order: 'styles, primeng, another-css-library'
                    }
                },
            },
            // Tradução pt-BR dos componentes PrimeNG (calendários, paginadores etc.).
            translation: {
                // Operadores de filtro (menus de filtro das tabelas).
                startsWith: 'Começa com',
                contains: 'Contém',
                notContains: 'Não contém',
                endsWith: 'Termina com',
                equals: 'Igual',
                notEquals: 'Diferente',
                noFilter: 'Sem filtro',
                lt: 'Menor que',
                lte: 'Menor ou igual a',
                gt: 'Maior que',
                gte: 'Maior ou igual a',
                dateIs: 'Data é',
                dateIsNot: 'Data não é',
                dateBefore: 'Data antes de',
                dateAfter: 'Data depois de',
                clear: 'Limpar',
                apply: 'Aplicar',
                matchAll: 'Corresponder a todos',
                matchAny: 'Corresponder a qualquer',
                addRule: 'Adicionar regra',
                removeRule: 'Remover regra',
                // Botões de ação padrão (confirm dialog, upload etc.).
                accept: 'Sim',
                reject: 'Não',
                choose: 'Escolher',
                upload: 'Enviar',
                cancel: 'Cancelar',
                // Calendário / datepicker.
                dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sá'],
                monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
                    'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                chooseYear: 'Escolher ano',
                chooseMonth: 'Escolher mês',
                chooseDate: 'Escolher data',
                prevDecade: 'Década anterior',
                nextDecade: 'Próxima década',
                prevYear: 'Ano anterior',
                nextYear: 'Próximo ano',
                prevMonth: 'Mês anterior',
                nextMonth: 'Próximo mês',
                prevHour: 'Hora anterior',
                nextHour: 'Próxima hora',
                prevMinute: 'Minuto anterior',
                nextMinute: 'Próximo minuto',
                prevSecond: 'Segundo anterior',
                nextSecond: 'Próximo segundo',
                am: 'AM',
                pm: 'PM',
                today: 'Hoje',
                weekHeader: 'Sem',
                firstDayOfWeek: 0,
                dateFormat: 'dd/mm/yy',
                // Medidor de senha.
                weak: 'Fraca',
                medium: 'Média',
                strong: 'Forte',
                passwordPrompt: 'Digite uma senha',
                // Mensagens de vazio (tabelas, selects, autocompletes) — antes vinham em inglês.
                emptyMessage: 'Nenhum registro encontrado',
                emptyFilterMessage: 'Nenhum resultado encontrado',
                emptySearchMessage: 'Nenhum resultado encontrado',
                searchMessage: '{0} resultados disponíveis',
                selectionMessage: '{0} itens selecionados',
                emptySelectionMessage: 'Nenhum item selecionado',
                aria: {
                    trueLabel: 'Verdadeiro',
                    falseLabel: 'Falso',
                    nullLabel: 'Não selecionado',
                    star: '1 estrela',
                    stars: '{star} estrelas',
                    selectAll: 'Todos os itens selecionados',
                    unselectAll: 'Todos os itens desmarcados',
                    close: 'Fechar',
                    previous: 'Anterior',
                    next: 'Próximo',
                    navigation: 'Navegação',
                    scrollTop: 'Rolar para o topo',
                    moveTop: 'Mover para o topo',
                    moveUp: 'Mover para cima',
                    moveDown: 'Mover para baixo',
                    moveBottom: 'Mover para o fim',
                    pageLabel: 'Página {page}',
                    firstPageLabel: 'Primeira página',
                    lastPageLabel: 'Última página',
                    nextPageLabel: 'Próxima página',
                    previousPageLabel: 'Página anterior',
                    rowsPerPageLabel: 'Linhas por página',
                    jumpToPageDropdownLabel: 'Ir para a página',
                    jumpToPageInputLabel: 'Ir para a página'
                }
            },
        }),
    ],
}).catch((err) => console.error(err));
